const MEMBERSHIP_MONTHLY = 'MEMBERSHIP_MONTHLY';
const MEMBERSHIP_ANNUAL = 'MEMBERSHIP_ANNUAL';
const GIFTED_MEMBERSHIP_ANNUAL = 'GIFTED_MEMBERSHIP_ANNUAL';

const ALL_ACCESS = 'ALL_ACCESS';

const APPLYING_JOBS_PROGRAM = 'APPLYING_JOBS_PROGRAM';
const ACE_INTERVIEW_PROGRAM = 'ACE_INTERVIEW_PROGRAM';
const CAREER_COACHING_PROGRAM = 'CAREER_COACHING_PROGRAM';
const NEGOTIATION_PROGRAM = 'NEGOTIATION_PROGRAM';

const COACHING_SESSION = 'COACHING_SESSION';
const COACHING_SESSION_3_PACK = 'COACHING_SESSION_3_PACK';
const COACHING_SESSION_5_PACK = 'COACHING_SESSION_5_PACK';
const COACHING_SESSION_20_PERCENT_OFF = 'COACHING_SESSION_20_PERCENT_OFF';

const RESUME_REVIEW = 'RESUME_REVIEW';
const RESUME_REVIEW_CALL = 'RESUME_REVIEW_CALL';

module.exports = {
  MEMBERSHIP_MONTHLY,
  MEMBERSHIP_ANNUAL,
  GIFTED_MEMBERSHIP_ANNUAL,
  ALL_ACCESS,
  APPLYING_JOBS_PROGRAM,
  ACE_INTERVIEW_PROGRAM,
  CAREER_COACHING_PROGRAM,
  NEGOTIATION_PROGRAM,
  COACHING_SESSION,
  COACHING_SESSION_3_PACK,
  COACHING_SESSION_5_PACK,
  COACHING_SESSION_20_PERCENT_OFF,
  RESUME_REVIEW,
  RESUME_REVIEW_CALL,
};
